import { useLocalObservable } from 'mobx-react-lite';
import { AiConnectionStore } from '../../stores/ai-adapter.store';

export const useAi = () => {
    const store = useLocalObservable(() => new AiConnectionStore());

    return {
        askAi: store.ask.bind(store),
        loading: store.loading,
        error: store.error,
    };
};
